module.exports = __webpack_public_path__ + "viaplay-logo-d66fb5d9d140ea3df7f99fce8fce80bb.png";


//////////////////
// WEBPACK FOOTER
// ./assets/viaplay-logo.png
// module id = 1204
// module chunks = 1 2